import React,{useState} from "react";
import { toast } from "react-toastify";
import { saveCoursesAlert } from "../../services/apiService";
import ENUMS from "../../utils/ENUMS";


const AdAccordion = ({alert}) =>{
    const token = localStorage.getItem(ENUMS.AUTH);
    

    const { color_hexcode, label } = alert.alert_type;
    const { title } = alert;

    const [alertData, setAlertData] = useState({ ...alert});
    const [isActive, setIsActive] = useState(false);
    const [selected,setSelected] = useState(null);

    const saveAlert = () => {
        console.log(alertData, "data")
        saveCoursesAlert(token, alertData).then(
            toast.success("Alert Data Saved Successfully")

        ).catch((err) => toast.error("Alert Save Error"));
    }

    const i=0;

    const toggle = (i) =>{
        if(selected === i)
            {
                return setSelected(null)
            }
            setSelected(i)
    }
    return(
        <>
            <div className="acc-alert__accordion_content">
                <button className="text-jost-sb-24-blk acc-alert__accordion_btn" style={{background: color_hexcode}} onClick={() => toggle(0)} onClick={() => setIsActive(!isActive)}>{label}
                </button>
                {
                    isActive &&  <div style={{backgroundColor: color_hexcode,borderTop:"2px solid rgba(255,255,255,0.5)"}} className="acc-alert__accordion_content_panel">
                        {/* <p className="text-ops-rg-16-wt">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean porta, felis vitae accumsan semper, urna velit consequat nibh. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean porta, felis vitae accumsan semper, urna velit consequat nibh.</p> */}
                        <h2 className="text-jost-sb-19-wt"> Customise your alert messaging (Max 20 words)</h2>
                        <textarea id="subject" readOnly={!alertData.use_new_message} onChange={(e) => setAlertData({ ...alertData, message: e.target.value })} value={alertData.use_new_message ? alertData.message || ""  : alertData.default_message } name="" placeholder="Type your customized message here... "  maxlength="180" required></textarea>

                        <div  className={selected===i?'acc-alert__accordion_content_panel-btn show':'acc-alert__accordion_content_panel-btn'}>
                            <div className="form__right__submit-check">

                                <input type="checkbox" id={`agree ${alert.id}`} name="" onChange={ () => {
                                    setAlertData({ ...alertData, use_new_message: !alertData.use_new_message })
                                    // console.log(!alertData.use_new_message);
                                }} checked={!alertData.use_new_message}/>
                                <label htmlFor={`agree ${alert.id}`}  className="checkmark"></label>
                                <span>Use Default Message</span>
                            </div>
                            <a href="#" target="_self" onClick={saveAlert} className="res-btn-primary btn-white">Save</a>
                        </div>
                    </div>
                }


            </div>
        </>
    );
};
export default AdAccordion;